import React from "react";
import { motion } from "framer-motion";
import {
  Cpu,
  ShoppingBag,
  Utensils,
  Stethoscope,
  Building,
  Truck,
  Briefcase,
  Gem,
  Film,
  GraduationCap,
  Plane,
  Hammer,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Cpu, name: "Technology & SaaS", copy: "AI, fintech, Web3 and software studios." },
  { icon: ShoppingBag, name: "E-commerce & Retail", copy: "D2C brands, marketplaces and stores." },
  { icon: Utensils, name: "Food & Beverage", copy: "Restaurants, cloud kitchens, FMCG." },
  { icon: Stethoscope, name: "Healthcare & Wellness", copy: "Clinics, medical devices, wellness." },
  { icon: Building, name: "Real Estate", copy: "Brokerage, development, PropTech." },
  { icon: Truck, name: "Logistics & Trading", copy: "Freight, import-export, 3PL." },
  { icon: Briefcase, name: "Consulting & Services", copy: "Management, legal, advisory firms." },
  { icon: Gem, name: "Luxury & Jewellery", copy: "DMCC-backed precious trade." },
  { icon: Film, name: "Media & Creative", copy: "Production, content, marketing agencies." },
  { icon: GraduationCap, name: "Education & EdTech", copy: "Training, schools, online platforms." },
  { icon: Plane, name: "Tourism & Hospitality", copy: "Travel, hotels, events, F&B groups." },
  { icon: Hammer, name: "Construction", copy: "Contracting, MEP, infrastructure." },
];

export default function IndustriesGrid() {
  return (
    <section
      data-testid="industries-section"
      className="relative bg-[#F8FAFC] py-20 md:py-32"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="overline text-[#3366FF]">Industries we serve</p>
          <div className="gold-rule mt-5 mb-6" />
          <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Specialists across{" "}
            <span className="font-black text-[#002366]">every sector</span> that calls the
            UAE home.
          </h2>
          <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
            From solo consultants to 500-person operations, StartINC tailors your
            licensing, visa strategy and compliance posture to the realities of your
            industry — not a generic template.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
          {INDUSTRIES.map(({ icon: Icon, name, copy }, i) => (
            <motion.div
              key={name}
              data-testid={`industry-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.06 }}
              className="bg-white p-6 md:p-7 group hover:bg-[#EEF2FF]/70 transition-colors duration-300"
            >
              <Icon
                className="w-7 h-7 md:w-8 md:h-8 text-[#3366FF] group-hover:text-[#002366] transition-colors"
                strokeWidth={1.5}
              />
              <h3 className="mt-5 font-heading font-semibold text-base md:text-lg tracking-tight text-[#0F172A]">
                {name}
              </h3>
              <p className="mt-1.5 text-xs md:text-sm text-slate-600 leading-relaxed">
                {copy}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
